import { Close } from "@mui/icons-material";
import {  useState } from "react";
import { Link } from "@mui/material";
import PdfPreview from "helpers/PdfPreview";
import { getFileMime } from "helpers/Common_functions";
import OpenDocument from "helpers/openDocument";

const FileUpload = (props) => {
  const { files } = props;
  const [openDocument, setOpenDocument] = useState(false);
  const [openCurrentFile, setOpenCurrentFile] = useState(false);
  const [document, setDocument] = useState();
  const currentFile = typeof files === "string" ? files : null;
  const arrayFiles =files? Object.values(files):undefined;
  
  return (
    <div className={"mb-3 "}>
      <div className="input-group mb-3 d-flex">
        {/* <button className="btn btn-primary" type="button" onClick={handleClick}>
          {title ?? "Add New File"}
        </button> */}
        {currentFile !== null ? (
          <div className="border flex-grow-1 rounded-end-2 d-flex align-items-center">
            <div
              className="btn-group ms-2 p-1 bg-light"
              role="button"
              onClick={() => {
                setOpenCurrentFile(true);
              }}
            >
              <Link className="me-2 ">{"open file"}</Link>
            </div>
          </div>
        ) : (
          <div className="border flex-grow-1 rounded-end-2 d-flex align-items-center">
            {arrayFiles?.map((file, index) => (
              <Link key={index} className="btn-group ms-2 p-1 me-1">
                <span
                  className="me-2"
                  role="button"
                  onClick={() => {
                    setOpenDocument(true);
                    setDocument(file);
                  }}
                >
                  {file?.name}
                </span>
              </Link>
            ))}

            {files && !files?.length ? (
              // <Link className="me-2 ">{"open file"}</Link>
              <Link className="btn-group ms-2 p-1  me-1">
                <span
                  className="me-2"
                  role="button"
                  onClick={() => {
                    setOpenDocument(true);
                    setDocument(files);
                  }}
                >
                  {files?.name}
                </span>
              </Link>
            ) : null}
          </div>
        )}
      </div>

      {openDocument ? (
        <div className="row bg-light">
          {" "}
          <div className="d-flex justify-content-end col-md-12 mb-2">
            <Close
              color="error"
              className=" border"
              type="button"
              onClick={() => {
                setOpenDocument(false);
              }}
            />
          </div>
          {openDocument && document ? (
            <div className="col-md-12">
              <PdfPreview
                mimeType={document?.type ?? "application/pdf"}
                document={URL.createObjectURL(document)}
              />
            </div>
          ) : null}
        </div>
      ) : null}

      {openCurrentFile ? (
        <div className={"row justify-content-center"}>
          <div className="d-flex justify-content-end col-md-12 mb-2">
            <Close
              color="error"
              className=" border"
              type="button"
              onClick={() => {
                setOpenCurrentFile(false);
              }}
            />
          </div>
          <div className="col-md-12">
            {/* {checkCurrentFile?.map((v) => ( */}
            <OpenDocument
              downloadable={true}
              card={true}
              document={currentFile}
              mimeType={getFileMime(currentFile)}
            />
            {/* // ))} */}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FileUpload;
